module.exports = ".disabled{\r\n    color: #ccc;\r\n}"